module.exports = __webpack_public_path__ + "images/a5991a0a19b407d9657fd67f672c905d.svg";